// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__f7RR0","arrow":"MenuItem_arrow__N66Mn"};